module.exports = __webpack_public_path__ + "static/70-seat-coach-hire-6a81877dc65bf24a7e13578558dad593.jpg";